import { McAction } from '../IMcAction';
import initialState, { ICommonDataState } from '../modules/common-data/ICommonDataState';
import {
    GET_ALL_TEA_CONFIGS,
    GET_ALL_SEVERITY_OF_HARM_VALUES,
    GET_ALL_DATE_RANGE_VALUES,
    GET_ALL_GROUP_TYPES,
    GET_ALL_QC_RULES_VALUES
} from '../modules/common-data/common-data.action.const';

import {
    getAllTeaConfigs,
    getSeverityOfHarmValues,
    getDateRangeValues,
    getDataRangeGroupType,
    getQcRuleValues
} from '../modules/common-data/common-data.reducer.logic';

export function commonDataReducer(state: ICommonDataState = initialState, action: McAction) {
    switch (action.type) {
        case GET_ALL_TEA_CONFIGS:
            return getAllTeaConfigs(state, action);

        case GET_ALL_SEVERITY_OF_HARM_VALUES:
            return getSeverityOfHarmValues(state, action);

        case GET_ALL_DATE_RANGE_VALUES:
            return getDateRangeValues(state, action);

        case GET_ALL_GROUP_TYPES:
            return getDataRangeGroupType(state, action);

        case GET_ALL_QC_RULES_VALUES:
            return getQcRuleValues(state, action);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/common-data.reducer.ts